import React from 'react';

import {SkeletonWrapper} from '../../../../components/Skeleton';

const NUM_ROWS = 5;

export const StorageTableRowLoading = () => {
  return (
    <>
      {Array.from({length: NUM_ROWS}, (_, i) => (
        <div className="p-8" key={i}>
          <SkeletonWrapper>
            <div className="h-24 w-full rounded bg-moon-250" />
          </SkeletonWrapper>
        </div>
      ))}
    </>
  );
};
